// src/pages/profile/AccountSettingsPage.jsx
import React, { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { updatePassword, updateEmail, reauthenticateWithCredential, EmailAuthProvider } from 'firebase/auth';
import { auth } from '../../services/firebase'; // eslint-disable-line no-unused-vars


import '../../styles/profile/AccountSettingsPage.css'; // for AccountSettingsPage


const AccountSettingsPage = () => {
  const { currentUser } = useAuth();
  const [email, setEmail] = useState(currentUser?.email || '');
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const reauthenticate = (currentPassword) => {
    const credential = EmailAuthProvider.credential(currentUser.email, currentPassword);
    return reauthenticateWithCredential(currentUser, credential);
  };

  const handleUpdateEmail = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    try {
      await reauthenticate(currentPassword);
      await updateEmail(currentUser, email);
      setMessage('Email updated successfully!');
    } catch (err) {
      setError(err.message);
    }
  };

  const handleUpdatePassword = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    if (newPassword !== confirmPassword) {
      setError('New passwords do not match');
      return;
    }
    try {
      await reauthenticate(currentPassword);
      await updatePassword(currentUser, newPassword);
      setMessage('Password updated successfully!');
      setNewPassword('');
      setConfirmPassword('');
      setCurrentPassword('');
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="account-settings-page">
      <div className="container">
        <h1>Account Settings</h1>

        {message && <div className="success-message">{message}</div>}
        {error && <div className="error-message">{error}</div>}

        <section className="settings-section">
          <h2>Change Email</h2>
          <form onSubmit={handleUpdateEmail}>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="New email"
              required
            />
            <input
              type="password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              placeholder="Current password"
              required
            />
            <button type="submit">Update Email</button>
          </form>
        </section>

        <section className="settings-section">
          <h2>Change Password</h2>
          <form onSubmit={handleUpdatePassword}>
            <input
              type="password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              placeholder="Current password"
              required
            />
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="New password"
              required
            />
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Confirm new password"
              required
            />
            <button type="submit">Update Password</button>
          </form>
        </section>
      </div>
    </div>
  );
};

export default AccountSettingsPage;